export const VAT_VALIDATION_ERROR_MESSAGE = 'VAT code is invalid'

export const validateVatNumberField = async ({
	validateVatNumber,
	vatNumber,
	countryCode,
	errors,
	fieldName
}) => {
	const normalizedVatNumber = typeof vatNumber === 'string' ? vatNumber.trim() : vatNumber
	const normalizedCountryCode = typeof countryCode === 'string' ? countryCode.trim().toUpperCase() : countryCode

	if (errors && fieldName) {
		errors.remove(fieldName)
	}

	if (!normalizedVatNumber) {
		return true
	}

	if (!normalizedCountryCode) {
		return true
	}

	const result = await validateVatNumber({
		vatNumber: normalizedVatNumber,
		countryCode: normalizedCountryCode
	})

	const isValid = !!result?.valid

	if (!isValid && errors && fieldName) {
		errors.add({ field: fieldName, msg: VAT_VALIDATION_ERROR_MESSAGE })
	}

	return isValid
}
